import React from 'react';
import { Box, Tab, Tabs, ThemeProvider, createTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import colors from "../../../../assets/theme/base/colors";
import { isNullOrEmpty } from '../../../Model/helpers';
const { primary } = colors;

const customTabTheme = createTheme({
    palette: { ...colors },
    components: {
        MuiTab: {
            styleOverrides: {
                root: {
                    color: primary.main,
                    '&:hover': {
                        color: primary.main,
                    }
                },
            },
        }
    },
});

interface IProps {
    currentTab: string | undefined;
    tabsData: { route: string; label: string }[];
    noRedirect?: boolean;
    onChange?: (newValue: string) => void;
}

export const SimpleTab = (props: IProps) => {
    const renderTabs = () => {
        if (props.noRedirect) {
            return props.tabsData.map((tab, index) => {
                return (
                    <Tab
                        key={index}
                        label={tab.label}
                        value={tab.route}

                    />
                );
            });
        }
        else {
            return props.tabsData.map((tab, index) => {
                return (
                    <Tab
                        key={index}
                        label={tab.label}
                        value={tab.route}
                        to={tab.route}
                        component={Link}
                    />
                );
            });
        }
    };

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        props.onChange  && !isNullOrEmpty(newValue) && props.onChange(newValue)
    };

    return (
        <ThemeProvider theme={customTabTheme}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 1 }}>
                <Tabs
                    value={props.currentTab}
                    aria-label="SimpleTabs"
                    onChange={handleChange}
                >
                    {renderTabs()}
                </Tabs>
            </Box>
        </ThemeProvider>
    );
};


